/**
 * Decorative backdrop for login/signup: soft aurora blobs and a faint dot grid.
 * Purely visual — absolutely positioned and non-interactive.
 */
export const LoginSignupBackdrop = () => (
  <div
    aria-hidden
    className="pointer-events-none absolute inset-0 overflow-hidden"
  >
    <div className="absolute top-[4%] left-1/2 h-[48%] w-[72%] -translate-x-1/2 rounded-full bg-[radial-gradient(closest-side,rgb(var(--gradient-wash-rgb)/0.28),transparent)] blur-3xl" />
    <div className="absolute top-[18%] left-[0%] h-[42%] w-[32%] rounded-full bg-[radial-gradient(closest-side,rgba(255,170,96,0.22),transparent)] blur-3xl" />
    <div className="absolute top-[24%] right-[2%] h-[44%] w-[34%] rounded-full bg-[radial-gradient(closest-side,rgba(96,210,160,0.2),transparent)] blur-3xl" />
    <div className="absolute bottom-[6%] left-[18%] h-[36%] w-[46%] rounded-full bg-[radial-gradient(closest-side,rgb(var(--gradient-wash-rgb)/0.1),transparent)] blur-3xl" />

    <div className="absolute inset-0 [background-image:radial-gradient(hsl(220_20%_12%/0.07)_1px,transparent_1px)] [background-size:22px_22px] [mask-image:radial-gradient(ellipse_70%_50%_at_50%_42%,black,transparent)]" />
  </div>
)
